module.exports = __webpack_public_path__ + "img/register_success.8106d23e.svg";